module.exports = __webpack_public_path__ + "images/icons/icon-step-complete-e78b8518.svg";